import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../services/api";

const Payment = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | failed
  const calledRef = useRef(false); // ✅ tekrar çağrılmayı engellemek için

  useEffect(() => {
    const authority = searchParams.get("Authority");
    const statusParam = searchParams.get("Status");

    if (!authority || !statusParam) {
      setStatus("failed");
      return;
    }

    if (calledRef.current) return; // ✅ ikinci kez çağrılmasın
    calledRef.current = true;

    const verifyPayment = async () => {
      try {
        const res = await api.post("/user/wallet/deposit/verify/", {
          authority,
          status: statusParam,
        });

        if (res.status === 200) {
          setStatus("success");
        } else {
          setStatus("failed");
        }
      } catch (err) {
        console.error("Payment Verify Error:", err);
        setStatus("failed");
      }
    };

    verifyPayment();
  }, [searchParams]);

  if (status === "loading") {
    return (
      <div className="w-full flex flex-col mt-16 justify-center items-center">
        <p className="text-[20px] text-[#ABB1CC]">در حال بررسی تراکنش...</p>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="w-full flex flex-col mt-16 justify-center items-center">
        <img src="/success.png"/>
        <div className="w-full flex justify-center items-center mt-4">
          <p className="text-[25px] text-green-500 font-extrabold">
            پرداخت موفقیت‌آمیز بود
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col mt-16 justify-center items-center">
      <img src="/nf.png" alt="" />
      <div className="w-full flex justify-center items-center mt-4">
        <p className="text-[25px] text-[#E51C44] font-extrabold">عملیات ناموفق</p>
      </div>
      <p className="text-[#ABB1CC] mt-2">مشکلی در پرداخت شما به وجود آمد :(</p>
    </div>
  );
};

export default Payment;
